<template>
  <v-flex xs12>
    <v-list-tile
      router
      :to="{name: 'search-view', params: { id: search.id }}"
      v-for="search in searches"
      :key="search.id"
    >
      <v-list-tile-content>
        <v-list-tile-title>{{ search.name }}</v-list-tile-title>
        <v-list-tile-sub-title>{{ getDescription(search.data) }}</v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>
  </v-flex>
</template>

<script>
  import mixinsSearch from '@/mixins/search'

  export default {
    mixins: [mixinsSearch]
  }
</script>


// WEBPACK FOOTER //
// src/components/search/SearchList.vue